<template>
  <div class="lineup-header">
    <div class="cap-lineup">
      <cap
        :cap="$consts.MEGA_LEAGUE.CAP"
        :max-player="$consts.MEGA_LEAGUE.PLAYER_COUNT"
        :players="players"
        :game-week="gameWeek"
        :lineup="lineup"
      />
    </div>
    <formation
      :modelValue="modelValue"
      :is-loading="isLoading"
      :read-only="!gameWeek.isOpen()"
      @update:modelValue="$emit('update:modelValue', $event)"
    />
  </div>
</template>

<script>
import Cap from '@/components/MegaLeague/Cap.vue';
import Formation from '@/components/MegaLeague/Formation.vue';
import GameWeek  from '@/models/GameWeek/gameWeek.js';
import lineup from '@/models/Lineup/lineup.js';

export default {
  name: 'LineupHeader',
  components: {
    Cap,
    Formation,
  },
  props: {
    modelValue: {
      type: String,
      default: '4-4-2',
    },
    players: {
      type: Array,
      default() {
        return [];
      },
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    gameWeek: {
      type: GameWeek,
      default: null,
    },
    lineup: {
      type: lineup,
      default() {
        return {};
      },
    }
  },
};

</script>

<style lang="scss">
  .lineup-header{
    display: flex;
    justify-content: space-between;
    .cap-lineup{
      display: flex;
      flex-direction: column;
      width: 50%;
      min-height: 122px;
      .text-h4{
        align-self: flex-start;
      }
    }
    .formation{
      width: min-content;
    }
  }

  @media (max-width:500px){
    .lineup-header{
      flex-direction: column;
      align-items: center;
      gap: 20px;
      margin-bottom: 20px;
      .cap-lineup{
        width: 90%;
        .text-h4{
          align-self: center;
        }
      }
    }
  }
</style>


